export const ASSET_VERSION: string = __BUILD_HASH__;